/* eslint-disable */
import React, { Component } from 'react'


import Svg, {
    Circle,
    Ellipse,
    G,
    LinearGradient,
    RadialGradient,
    Line,
    Path,
    Polygon,
    Polyline,
    Rect,
    Symbol,

    Use,
    Defs,
    Stop
} from 'react-native-svg';


export const SvgMyShop = ({ size }) => {
    return (<Svg
        height={size}
        width={size}
        viewBox="0 0 48 48" >
        <Defs></Defs>
        <G id="Bar-with-caption-box" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-190.000000, -74.000000)" strokeLinecap="round" strokeLinejoin="round">
            <G id="Group-3" transform="translate(192.000000, 76.000000)" stroke="#1A1A1A" strokeWidth="3">
                <Circle id="Oval" cx="11" cy="11" r="4"></Circle>
                <Path d="M42.6652248,26.1935189 L26.2096217,42.6534251 C25.3486597,43.5155709 24.1803692,44 22.9621073,44 C21.7438453,44 20.5755548,43.5155709 19.7145928,42.6534251 L0,22.9566336 L0,0 L22.9506319,0 L42.6652248,19.7197482 C44.4449251,21.5105376 44.4449251,24.4027295 42.6652248,26.1935189 Z" id="Shape"></Path>
            </G>
        </G>

    </Svg>)
}

